import {
  Box,
  Center,
  Menu,
  MenuButton,
  MenuDivider,
  MenuGroup,
  MenuItem,
  MenuList,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Spinner,
  useDisclosure,
} from '@chakra-ui/react';
import { skipToken } from '@tanstack/react-query';
import { Trans } from '@lingui/react/macro';
import { t } from '@lingui/core/macro';
import { getUserFullName } from '@duke-hq/lib';
import { useAuthAdmin } from '../AuthProviderAdmin';
import { useCheckPermission } from '../hooks/useCheckPermission';
import { KeyRound, LogOut } from 'lucide-react';
import { Txt } from '@duke-hq/app-admin-web/components/util/Txt';
import { UserAvatar } from '@duke-hq/ui/components/UserAvatar/UserAvatar';
import { iconSize } from '@duke-hq/ui/constants/scalable';
import { AdminUserPermissionsTab } from '../Users/AdminUserDetailTabs/AdminUserPermissionsTab';
import { trpcAdmin } from '@duke-hq/app-admin-web/lib/trpcAdmin';

export function AdminUserAvatarMenu() {
  const auth = useAuthAdmin();
  const canAccessDeveloperTools = useCheckPermission('canAccessDeveloperTools');
  const { isOpen, onClose, onOpen } = useDisclosure();
  const { data: user, isLoading } = trpcAdmin.users.byId.useQuery(auth.user?.id ?? skipToken, {
    enabled: isOpen,
  });

  return (
    <>
      <Menu>
        <MenuButton aria-label={t`Account menu`}>
          {auth.user ? <UserAvatar user={auth.user} /> : null}
        </MenuButton>
        <MenuList>
          {auth.user ? (
            <>
              <MenuGroup>
                <Box px={3} py={2}>
                  <Txt fontWeight="semibold" fontSize="sm" noOfLines={1}>
                    {getUserFullName(auth.user) || auth.user.email}
                  </Txt>
                  {auth.user.email !== null && getUserFullName(auth.user) ? (
                    <Txt fontSize="xs" color="fg.muted" noOfLines={1}>
                      {auth.user.email}
                    </Txt>
                  ) : null}
                </Box>
              </MenuGroup>
              <MenuDivider />
            </>
          ) : null}
          {canAccessDeveloperTools ? (
            <MenuItem onClick={onOpen}>
              <KeyRound size={iconSize.md} />{' '}
              <Txt ml={4}>
                <Trans>My Permissions</Trans>
              </Txt>
            </MenuItem>
          ) : null}
          <MenuItem
            onClick={async () => {
              auth.signOut();
            }}
          >
            <LogOut size={iconSize.md} />{' '}
            <Txt ml={4}>
              <Trans>Sign Out</Trans>
            </Txt>
          </MenuItem>
        </MenuList>
      </Menu>
      <Modal isOpen={isOpen} onClose={onClose} size="2xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            <Trans>My Permissions</Trans>
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody p={0} maxH="70vh" overflowY="auto">
            {isLoading || user == null ? (
              <Center py={8}>
                <Spinner />
              </Center>
            ) : (
              <AdminUserPermissionsTab user={user} />
            )}
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
}
